<template>
  <div class="page __bc-f2">
    <!-- 页面下拉刷新 -->
    <cp-page-refresh @refresh="refresh" ref="pageRefresh">
      <!-- 公共头部组件 -->
      <common-header />
      <div class="container">
        <!-- 课程视频轮播 -->
        <video-swiper
          v-if="bannerList.length"
          :swiperLoop="false"
          :autoplay="false"
          :showBottomMask="false"
          :list="bannerList"
          :swiperIndex="swiperIndex"
          :stopSwiping="true"
          @handle-click-slide="handleClickSlide"
          @handle-change-slide="handleChangeSlide"
        />
        <!-- 课程tabs -->
        <common-tabs v-show="bannerList.length" :tabNum="currentIndex" :list="bannerList" :canSwipeNum="4" ref="typeTabs" @change-tab="changeTab">
          <!-- 课程tab内容 -->
          <div class="tab-session">
            <!-- 不同课程动态组件 -->
            <component :is="currentComp" :filterId="filterId" :tabIndex="courseId" :currentIndex="currentIndex" :swiperIndex="swiperIndex"></component>
          </div>
        </common-tabs>
      </div>
    </cp-page-refresh>
    <!-- 悬浮的筛选图标 -->
    <div class="filterBtn" @click="showPicker = true" v-show="filterBtnShow">
      <img src="./../../assets/images/icon/screening_icon.png" />
    </div>
    <!-- 筛选选择器 -->
    <van-popup v-model="showPicker" round position="bottom">
      <div class="filter-option-contain">
        <div class="title-contain">
          <div class="legen-icon"></div>
          <p class="title">党建课程</p>
        </div>
        <van-radio-group v-model="filterOption">
          <van-radio v-for="(item,index) in filterList" :key="index" :name="item.id">
            <div :class="[(filterOption == item.id) ?'item-actived':'item-no-active','item']" v-text="item.name"></div>
          </van-radio>
        </van-radio-group>
        <van-goods-action>
          <van-goods-action-button color="#f2f2f2" type="warning" text="重置" @click="resetFilter"/>
          <van-goods-action-button color="#e50914" type="danger" text="完成" @click="onSureFIler"/>
        </van-goods-action>
      </div>
    </van-popup>
    <!-- 公共页脚 -->
    <foot-table />
  </div>
</template>

<script>
import LocalStorage from '@/utils/localStorage'
import FootTable from '@/views/layout/foot-table'
import CommonHeader from '@/views/layout/common-header'
import VideoSwiper from '@/views/components/video-swiper'
import CommonTabs from '@/views/components/common-tabs'
import PartyBuildCourse from './components/party-build-course.vue'
import CompanyBuildCourse from './components/company-build-course.vue'
import FeaturesCourse from './components/features-course.vue'
import PoliticalCourse from './components/political-course.vue'
import VRCourse from './components/vr-course.vue'
import ModelCourse from './components/model-course.vue'
import OverallViewCourse from './components/overall-view-course.vue'
import DefaultCourse from './components/default-course.vue'
import { course } from '@/agent'
export default {
  components: {
    'foot-table': FootTable,
    'common-header': CommonHeader,
    'video-swiper': VideoSwiper,
    'common-tabs': CommonTabs,
    'party-build-course': PartyBuildCourse,
    'company-build-course': CompanyBuildCourse,
    'features-course': FeaturesCourse,
    'political-course': PoliticalCourse,
    'vr-course': VRCourse,
    'model-course': ModelCourse,
    'overall-view-course': OverallViewCourse,
    'default-course': DefaultCourse,
  },
  data () {
    return {
      bannerList: [],
      swiperIndex: 0, // 轮播当前下标
      filterBtnShow: false, // 是否显示筛选按钮
      currentIndex: 0, // 当前课程-下标
      courseId: '', // 课程tab 的id
      filterId: '', // 筛选项id - 根据页签或者筛选项而变化
      upFinish: false, // 是否已加载全部
      currentComp: 'party-build-course', // 当前组件
      showPicker: false, // 筛选选择器是否显示
      filterOption: '', // 选择器选中的结果
      filterList: []
    }
  },
  computed: {
  },
  watch: {
    currentIndex: {
      immediate: true, // 很重要！！！
      handler (val) {
        this.swiperIndex = val
      }
    },
    $route (to, from) {
      if (this.$route.query.from == 'home') {
        if (LocalStorage.get('banner_list')) {
          let list = JSON.parse(LocalStorage.get('banner_list'))
          for (let m = 0; m < list.length; m++) {
            if (this.$route.query.session == 'partyCourse' || this.$route.query.session == 'companyCourse' || this.$route.query.session == 'featuresCourse' || this.$route.query.session == 'politicalCourse') {
              if (list[m].courseId == this.$route.query.tabIndex) {
                this.courseId = list[m].courseId
                this.currentIndex = m
                this.currentComp = list[m].componentName
                this.filterBtnShow = true
                this.filterId = this.courseId
                this.getFilterList(this.filterId)
                break
              }
            } else if (list[m].path == 'courseList?name=scene' && this.$route.query.session == 'vrCourse') {
              this.courseId = list[m].courseId
              this.currentIndex = m
              this.currentComp = list[m].componentName
              break
            } else if (list[m].path == 'courseList?name=model' && this.$route.query.session == 'modelCourse') {
              this.courseId = list[m].courseId
              this.currentIndex = m
              this.currentComp = list[m].componentName
              break
            } else if (list[m].path == 'courseList?name=panorama' && this.$route.query.session == 'overallCourse') {
              this.courseId = list[m].courseId
              this.currentIndex = m
              this.currentComp = list[m].componentName
              break
            }
          }
        } else {
          this.getFrontMenuList()
        }
      }
    }
  },
  created () {
    this.getFrontMenuList()
  },
  beforeRouteLeave (to, from, next) {
    // 设置滚动条位置
    const scrollTop = Math.abs(document.querySelector('.page').getBoundingClientRect().top)
    this.$util.setTabsLeaveSite(from.path, scrollTop)
    next()
  },
  mounted () {
    // 从course详情跳转到课程列表
    if (this.$route.query.from !== 'home') {
      if (!this.$route.query.currentIndex && !this.$route.query.swiperIndex) {
        // 从建党、建国、特色、思政课程详情跳转到课程列表
        this.courseId = this.$route.query.tabIndex ? this.$route.query.tabIndex : ''
      }
    }
  },
  methods: {
    // 下拉刷新页面
    refresh () {
      Object.assign(this.$data, this.$options.data()) // 重置data对象的数据为初始状态
      this.$refs.pageRefresh.hideFresh() // 隐藏下拉刷新
      this.getFrontMenuList()
      // 从course详情跳转到课程列表
      if (this.$route.query.from !== 'home') {
        if (!this.$route.query.currentIndex && !this.$route.query.swiperIndex) {
          // 从建党、建国、特色、思政课程详情跳转到课程列表
          this.courseId = this.$route.query.tabIndex ? this.$route.query.tabIndex : ''
        }
      }
    },
    // 头部轮播图和tablist
    getFrontMenuList () {
      this.$loading.show()
      LocalStorage.remove('banner_list')
      course.getFrontMenuList().then(res => {
        if (res.code == 100) {
          this.$loading.hide()
          res.data.map((item) => {
            if (item.name == 'selectedCourse' && item.path == 'courseList') {
              item.children.map(i => {
                if (i.name == 'courseList' && i.path == 'courseList') {
                  let list = i.children.map(j => {
                    j.dictLabel = j.title
                    j.courseId = this.getUrlParams(j.name).seriesId ? this.getUrlParams(j.name).seriesId : ''
                    switch (j.path) {
                      case 'courseList?name=found_party': {
                        j.componentName = 'party-build-course'
                        break
                      }
                      case 'courseList?name=found_state': {
                        j.componentName = 'company-build-course'
                        break
                      }
                      case 'courseList?name=characteristic': {
                        j.componentName = 'features-course'
                        break
                      }
                      case 'courseList?name=scene': {
                        j.componentName = 'vr-course'
                        break
                      }
                      // case "courseList?name=pc":{
                      //   j.componentName="vr-course";
                      //   break;
                      // }//-------------暂时屏蔽-------------
                      case 'courseList?name=panorama': {
                        j.componentName = 'overall-view-course'
                        break
                      }
                      case 'courseList?name=model': {
                        j.componentName = 'model-course'
                        break
                      }
                      // case 'courseList?name=characteristic': {
                      //   j.componentName = 'political-course'
                      //   break
                      // }
                      default : {
                        j.componentName = 'default-course'
                        break
                      }
                    }
                    return j
                  })
                  this.bannerList = list.filter(k => {
                    // showType-展示类型（1图片 2 视频（默认））;
                    if (k.showType == '1') {
                      k.bgVideo = ''
                      k.imgSrc = k.appBgImage
                    } else {
                      k.bgVideo = k.appBgVideo
                      k.imgSrc = ''
                    }
                    return k.path !== 'courseList?name=pc'
                  })
                  console.log('1111111111')
                  console.log(this.bannerList)
                  console.log('1111111111')
                  LocalStorage.set('banner_list', JSON.stringify(this.bannerList))
                  if (this.$route.query.from == 'home') {
                    for (let m = 0; m < this.bannerList.length; m++) {
                      if (this.$route.query.session == 'partyCourse' || this.$route.query.session == 'companyCourse' || this.$route.query.session == 'featuresCourse' || this.$route.query.session == 'politicalCourse') {
                        if (this.bannerList[m].courseId == this.$route.query.tabIndex) {
                          this.courseId = this.bannerList[m].courseId
                          this.currentIndex = m
                          this.currentComp = this.bannerList[m].componentName
                          this.filterBtnShow = true
                          this.filterId = this.courseId
                          this.getFilterList(this.filterId)
                          break
                        }
                      } else if (this.bannerList[m].path == 'courseList?name=scene' && this.$route.query.session == 'vrCourse') {
                        this.courseId = this.bannerList[m].courseId
                        this.currentIndex = m
                        this.currentComp = this.bannerList[m].componentName
                        break
                      } else if (this.bannerList[m].path == 'courseList?name=model' && this.$route.query.session == 'modelCourse') {
                        this.courseId = this.bannerList[m].courseId
                        this.currentIndex = m
                        this.currentComp = this.bannerList[m].componentName
                        break
                      } else if (this.bannerList[m].path == 'courseList?name=panorama' && this.$route.query.session == 'overallCourse') {
                        this.courseId = this.bannerList[m].courseId
                        this.currentIndex = m
                        this.currentComp = this.bannerList[m].componentName
                        break
                      }
                    }
                  } else if (!this.$route.query.currentIndex && !this.$route.query.swiperIndex) {
                    this.courseId = this.courseId ? this.courseId : this.bannerList[0].courseId
                    for (let i = 0; i < this.bannerList.length; i++) {
                      if (this.courseId == this.bannerList[i].courseId) {
                        if (this.bannerList[0].path == 'courseList?name=found_party' || this.bannerList[0].path == 'courseList?name=found_state' || this.bannerList[0].path == 'courseList?name=characteristic') {
                          this.filterBtnShow = true
                          this.filterId = this.courseId
                          this.getFilterList(this.filterId)
                        }
                        this.currentIndex = i
                        break
                      }
                    }
                  } else {
                    this.currentIndex = Number(this.$route.query.currentIndex)
                    this.swiperIndex = Number(this.$route.query.swiperIndex)
                    this.currentComp = 'model-course'
                  }
                }
              })
            }
          })
        }
      })
    },
    // 课程-建国、建党、特色、思政课程的内部筛选列表
    getFilterList (id) {
      course.getFilterList(id).then(res => {
        if (res.code == 100) {
          this.filterList = res.data[0].childrens
        } else {
          this.filterList = []
        }
      })
    },
    // 切换teb页，更换课程
    changeTab (index, item) {
      this.currentIndex = index
      // console.log(this.currentIndex)
      // console.log(this.courseId)
      // console.log(this.filterId)
      // console.log(item)
      this.filterOption = ''
      this.swiperIndex = index
      this.currentComp = item.componentName
      this.filterId = item.courseId
      this.courseId = item.courseId
      if (this.filterId) {
        this.filterBtnShow = true
        this.getFilterList(this.filterId)
      } else {
        this.filterBtnShow = false
      }
    },
    // 重置筛选选项
    resetFilter () {
      this.filterOption = ''
    },
    // 确定筛选选项，刷新接口，获得新的列表
    onSureFIler () {
      if (this.filterOption) {
        this.filterId = this.filterOption
      } else {
        this.filterId = this.courseId
      }
      this.showPicker = false
    },
    getUrlParams (url) {
      if (!url) {
        return {}
      } else {
        let paramsStr = url.split('?')[1]
        if (!paramsStr) {
          return {}
        } else {
          let obj = {}
          let paramsList = paramsStr.split('&')
          for (let i = 0; i < paramsList.length; i++) {
            let param = paramsList[i].split('=')
            obj[param[0]] = param[1]
          }
          return obj
        }
      }
    },
    // 点击新闻swiper
    handleClickSlide (currentIndex) {
      // console.log('22222');
    },
    // swiper发生改变
    handleChangeSlide (currentIndex) {
      // console.log('11111111111111');
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  min-height: 100%;
}
.container {
  padding: $header-height 0 $foot-table-height;
  // common-tabs组件背景色未吸顶灰色，吸顶白色
  /deep/.van-tabs__nav--line {
    background-color: #f2f2f2;
  }
   /deep/.van-sticky--fixed .van-tabs__nav--line {
    background-color: #fff;
  }
}
.news-list {
  min-height: calc(100vh - #{$header-height} - #{$foot-table-height} - 44px);
}
.filterBtn{
  width: 40px;
  height: 40px;
  background: #E50914;
  box-shadow: -4px 4px 18px 0px rgba(35, 2, 4, 0.5);
  border-radius: 50%;
  position: fixed;
  bottom:114px;
  right:16px;
  img{
    width: 40px;
    height: 40px;
    opacity: 1;
    position: absolute;
    left: 50%;
    top:50%;
    transform: translate(-50%,-50%);
    color: #FFFFFF;
  }
}
.filter-option-contain{
  padding: 15px;
  margin-bottom: 150px;
  .title-contain{
    display: flex;
    margin-bottom: 24px;
    .legen-icon{
      width: 2px;
      height: 15px;
      opacity: 1;
      background: #e50914;
      border-radius: 1px;
      margin-right: 8px;
    }
    .title{
      height: 15px;
      opacity: 1;
      font-size: 15px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 600;
      text-align: left;
      color: #282828;
      line-height: 15px;
    }
  }
  .item{
    width: 160px;
    height: 35px;
    border-radius: 18px;
    border: 1px solid #F2F2F2;
    line-height: 37px;
    text-align: center;
    margin-bottom: 12px;
  }
  .item-actived{
    background: #E50914;
    color: #F2F2F2;
  }
  .item-no-active{
    background: #F2F2F2;
    color: #252525;
  }
}

</style>
<style lang="scss">
.filter-option-contain{
  .van-radio-group{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .van-radio__label{
      margin: 0;
    }
  }
  .van-radio__icon{
    display: none !important;
  }
  .van-button--warning{
    .van-button__text{
      color:#252525;
    }
  }
}
</style>
